module.exports = __webpack_public_path__ + "static/media/my-bio.a09bc462.jpg";